export type DataFreshnessMode = 'daily' | 'on-demand' | 'paused'

interface DataFreshnessBadgeProps {
  date: string | null | undefined
  label?: string
  mode?: DataFreshnessMode
  staleAfterDays?: number
  compact?: boolean
}

const DAY_MS = 24 * 60 * 60 * 1000

const normalizedDate = (value: string) => value.match(/^\d{4}-\d{2}-\d{2}/)?.[0] || value

const dateParts = (value: string) => {
  const match = normalizedDate(value).match(/^(\d{4})-(\d{2})-(\d{2})$/)
  return match ? { year: Number(match[1]), month: Number(match[2]), day: Number(match[3]) } : null
}

const displayDate = (value: string) => {
  const parts = dateParts(value)
  return parts ? `${parts.month}月${parts.day}日` : normalizedDate(value)
}

const daysSince = (value: string) => {
  const parts = dateParts(value)
  if (!parts) return null
  const today = new Date()
  const todayUtc = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate())
  const valueUtc = Date.UTC(parts.year, parts.month - 1, parts.day)
  return Math.max(0, Math.floor((todayUtc - valueUtc) / DAY_MS))
}

export function DataFreshnessBadge({
  date,
  label = '数据截至',
  mode = 'daily',
  staleAfterDays = 2,
  compact = false,
}: DataFreshnessBadgeProps) {
  if (!date) {
    return <span className={`data-freshness-badge is-pending${compact ? ' is-compact' : ''}`}>等待数据日期</span>
  }

  const ageDays = daysSince(date)
  const stale = mode === 'daily' && ageDays !== null && ageDays > staleAfterDays
  const suffix = mode === 'on-demand'
    ? '按需更新'
    : mode === 'paused'
      ? '暂停更新'
      : stale
        ? `已超过${staleAfterDays}天未更新`
        : '日更正常'
  const tone = mode === 'daily' ? stale ? 'is-stale' : 'is-current' : 'is-on-demand'

  return (
    <span
      className={`data-freshness-badge ${tone}${compact ? ' is-compact' : ''}`}
      data-source-date={normalizedDate(date)}
      title={`${label} ${normalizedDate(date)} · ${suffix}`}
    >
      {label} {displayDate(date)} <b>· {suffix}</b>
    </span>
  )
}
